import {baseStyles} from "../styles";
import {Image, View, Text} from "@react-pdf/renderer";
import React, {useContext} from "react";
import {PDFContext} from "../BasePDF";

export const FooterPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{
            ...baseStyles.flexBetween,
            alignItems: 'center',
            alignContent: 'center',
            flexWrap: 'wrap',
            justifyContent: 'center',
            marginTop: '20px',
        }}>
            <View
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    padding: '3px 10px',
                    alignItems: 'center'
                }}
            >
                <Text
                    style={{
                        marginRight: '10px',
                        fontWeight: '700',
                        fontStyle: 'italic'
                }}
                >
                    Powered by:
                </Text>
                <Image
                    style={{ width: '200px'}}
                    src={"https://res.cloudinary.com/hgjsxpz9b/image/upload/v1765310173/Asset_4_4x-8_teyqav.png"}
                    alt="TrueDesking Logo"
                />
            </View>
        </View>
    )
}